import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import { Grid } from "@components/Grid/Grid";
import IcomBlock from "@components/Grid/IcomBlock";
import IComEditorGroup from "@components/IComEditorGroup/IComEditorGroup";

@inject("store")
@observer
export default class DocTypeInnerGrid extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
           
            <div className="inner-grid">
                {this.props.model.grid && <Grid {...this.props} model={this.props.model.grid} /> }
            </div>
        );
    }
}